import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";

export const bookmarkBorder = (props) => {
  return <BookmarkBorderIcon {...props} />;
};
